var endsWith = require('lodash/endsWith');

// Streamguys can't handle the shoutcast hack and returns a 404
// which puts the tuner in an unrecoverable error state, per TUNE-9293.
// Updating the regex to check for tunein and streamguys per TUNE-9806.
// Updating regex to check for tunein.com domain per TUNE-12042.
// Updating regex to check for mediatailor domain per TUNE-12078.
const NO_SHOUTCAST_REGEX = /tunein.*streamguys|tunein.com|mediatailor/;

function urlPathWithShoutcastSuffix(path) {
  var shoutcastSuffix = ';';

  if (endsWith(path, '/' + shoutcastSuffix)) {
    return path;
  }

  if (endsWith(path, '/')) {
    return path + shoutcastSuffix;
  }

  return path + '/' + shoutcastSuffix;
}

module.exports = {
  shoutcastStreamUrl: function (url) {
    if (NO_SHOUTCAST_REGEX.test(url)) {
      return url;
    }
    var queryIndex = url.indexOf('?');

    return queryIndex > -1
      ? urlPathWithShoutcastSuffix(url.substring(0, queryIndex)) +
          url.substring(queryIndex)
      : urlPathWithShoutcastSuffix(url);
  },
  isHLS: function (url) {
    return url.indexOf('.m3u8') > 0;
  },
  removeM3UExtension: function (url) {
    var m3uIndex = url.indexOf('.m3u');
    return m3uIndex > 0 ? url.slice(0, m3uIndex) : url;
  },
};
